module.exports = __webpack_public_path__ + "img/block-chain-3955939_1920.f1f50aa6.jpg";